import React, { useCallback, useEffect, useState } from "react";
import axios from "axios";
import { Loader2, Save, FileText } from "lucide-react";
import { toast } from "sonner";
import { API } from "../context/ShopContext";

const LegalPagesAdmin = ({ authHeaders }) => {
  const [pages, setPages] = useState([]);
  const [active, setActive] = useState(null);
  const [form, setForm] = useState(null);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);

  const load = useCallback(async () => {
    try {
      const { data } = await axios.get(`${API}/pages`);
      setPages(data);
    } catch {
      toast.error("Errore caricamento pagine");
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    load();
  }, [load]);

  const openPage = async (slug) => {
    setActive(slug);
    setForm(null);
    try {
      const { data } = await axios.get(`${API}/pages/${slug}`);
      setForm({
        title_it: data.title.it,
        title_en: data.title.en,
        content_it: data.content.it,
        content_en: data.content.en,
      });
    } catch {
      toast.error("Errore caricamento pagina");
    }
  };

  const save = async () => {
    if (!form.title_it.trim() || !form.title_en.trim()) {
      toast.error("Il titolo è obbligatorio (IT e EN)");
      return;
    }
    setSaving(true);
    try {
      await axios.put(`${API}/admin/pages/${active}`, form, authHeaders());
      toast.success("Pagina aggiornata");
      load();
    } catch (err) {
      toast.error(err.response?.data?.detail || err.message);
    } finally {
      setSaving(false);
    }
  };

  return (
    <section className="idm-admin-section" data-testid="admin-legal-pages">
      <h3 className="idm-admin-section-title">Pagine legali (footer)</h3>
      <p className="idm-admin-section-sub">
        Modifica i contenuti di Termini e condizioni, Norme sui rimborsi, Privacy e Cookie policy.
        Puoi inserire testo semplice (le righe che iniziano con "## " diventano titoli) oppure codice HTML completo.
      </p>
      {loading ? (
        <div className="idm-loading"><span className="idm-spinner" /></div>
      ) : (
        <>
          <div className="idm-cat-filters" style={{ marginBottom: 18 }}>
            {pages.map((p) => (
              <button
                key={p.slug}
                className={active === p.slug ? "active" : ""}
                onClick={() => openPage(p.slug)}
                data-testid={`legal-tab-${p.slug}`}
              >
                <FileText size={12} style={{ marginRight: 5, verticalAlign: -2 }} />
                {p.title.it}
              </button>
            ))}
          </div>
          {active && !form && <div className="idm-loading"><span className="idm-spinner" /></div>}
          {form && (
            <div className="idm-form-grid" data-testid="legal-edit-form">
              <div className="idm-field half">
                <label>Titolo (IT)</label>
                <input value={form.title_it} onChange={(e) => setForm({ ...form, title_it: e.target.value })} data-testid="legal-title-it" />
              </div>
              <div className="idm-field half">
                <label>Titolo (EN)</label>
                <input value={form.title_en} onChange={(e) => setForm({ ...form, title_en: e.target.value })} data-testid="legal-title-en" />
              </div>
              <div className="idm-field half">
                <label>Contenuto (IT)</label>
                <textarea rows={14} value={form.content_it} onChange={(e) => setForm({ ...form, content_it: e.target.value })} data-testid="legal-content-it" />
              </div>
              <div className="idm-field half">
                <label>Contenuto (EN)</label>
                <textarea rows={14} value={form.content_en} onChange={(e) => setForm({ ...form, content_en: e.target.value })} data-testid="legal-content-en" />
              </div>
              <div>
                <button className="idm-btn-yellow" style={{ animation: "none" }} onClick={save} disabled={saving} data-testid="legal-save">
                  {saving ? <Loader2 size={15} className="idm-spin" /> : <Save size={15} />} Salva pagina
                </button>
              </div>
            </div>
          )}
        </>
      )}
    </section>
  );
};

export default LegalPagesAdmin;
